import { render, staticRenderFns } from "./molecule.ugcSizeSelection.content.vue?vue&type=template&id=c185ee48"
import script from "./molecule.ugcSizeSelection.content.vue?vue&type=script&lang=ts"
export * from "./molecule.ugcSizeSelection.content.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports